import { createUserManager } from 'redux-oidc';
import { WebStorageStateStore } from 'oidc-client';
import config from '../config'

const getAppBaseUrl = () => {
  return `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`
}

const oidc_config = {
  authority: config.get('authority-url'),
  client_id: 'js.porownywarka',
  scope: 'openid profile api.porownywarka',
  response_type: 'code',
  redirect_uri: getAppBaseUrl() + '/sign-in',
  post_logout_redirect_uri: getAppBaseUrl() + '/sign-out',
  silent_redirect_uri: getAppBaseUrl() + '/silent-renew.html',
  checkSessionInterval: 30 * 1000, // 30sec
  clockSkew: 10 * 60, // 10min
  filterProtocolClaims: true,
  automaticSilentRenew: true,
  monitorSession: true,
  loadUserInfo: true,
  userStore: new WebStorageStateStore({ store: localStorage, prefix: 'oidc.' }),
  acr_values: 'ver:seller'
}

const userManager = createUserManager(oidc_config);

export default userManager;


// WEBPACK FOOTER //
// ./src/utils/userManager.js